import store from '@/store';
import availablePaymentEngines from '../constants/PaymentEngine';

/**
 * Types of cybersource error codes
 * this should be passend in the setError action to show an error message
 * */
const cybersourceErrorCodes = {
  contact_processor: 'cybersource.contact_processor',
  cv_failed: 'cybersource.cv_failed',
  cvn_not_match: 'cybersource.cvn_not_match',
  exceeds_credit_limit: 'cybersource.exceeds_credit_limit',
  expired_card: 'cybersource.expired_card',
  insufficient_fund: 'cybersource.insufficient_fund',
  invalid_account: 'cybersource.invalid_account',
  invalid_cvn: 'cybersource.invalid_cvn',
  processor_declined: 'cybersource.processor_declined',
  default: 'cybersource.default_error',
};

/**
 * Flag to indicate if it should use cybersource or not
 * @param {String} paymentEngine
 * @returns Boolean
 */
export function shouldUseCybersource(paymentEngine) {
  const cybersourceIsEnabled = store.getState().whitelabelConfig?.env?.cybersource?.enabled;
  return cybersourceIsEnabled && paymentEngine === availablePaymentEngines.cybersource;
}

/**
 * Decode the base64url-encoded payload segment of a JWT without verifying its signature.
 * @param {String} jwt - The JWT string (header.payload.signature)
 * @returns {Object|null} The decoded payload object, or null if it cannot be decoded
 */
function decodeJwtPayload(jwt) {
  try {
    const payloadSegment = jwt?.split('.')?.[1];
    if (!payloadSegment) return null;

    const base64 = payloadSegment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    return JSON.parse(atob(padded));
  } catch (error) {
    console.error('Failed to decode Cybersource transient token:', error);
    return null;
  }
}

/**
 * Extract the card BIN from a Cybersource transient token (microform JWT).
 * The microform hosted fields never expose raw digits in field events; the BIN
 * is only available in the transient token payload at
 * content.paymentInformation.card.number.bin.
 * @param {String} transientToken - The transient token JWT returned by microform.createToken
 * @returns {String|null} The BIN (typically 6 digits), or null if unavailable
 */
export function getBinFromCybersourceToken(transientToken) {
  const payload = decodeJwtPayload(transientToken);
  return payload?.content?.paymentInformation?.card?.number?.bin || null;
}

export default cybersourceErrorCodes;
